import { render, staticRenderFns } from "./UpdateRule.vue?vue&type=template&id=0eadf0a1&scoped=true"
import script from "./UpdateRule.vue?vue&type=script&lang=js"
export * from "./UpdateRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eadf0a1",
  null
  
)

export default component.exports